let Years = [
  {
    year: "2000",
  },
  {
    year: "2001",
  },
  {
    year: "2002",
  },
  {
    year: "2003",
  },
  {
    year: "2004",
  },
  {
    year: "2005",
  },
  {
    year: "2006",
  },
  {
    year: "2007",
  },
  {
    year: "2008",
  },
  {
    year: "2009",
  },
  {
    year: "2010",
  },
  {
    year: "2011",
  },
  {
    year: "2012",
  },
  {
    year: "2013",
  },
  {
    year: "2014",
  },
  {
    year: "2015",
  },
  {
    year: "2016",
  },
  {
    year: "2017",
  },
  {
    year: "2018",
  },
  {
    year: "2019",
  },
  {
    year: "2020",
  },
  {
    year: "2021",
  },
  {
    year: "2022",
  },
  {
    year: "2023",
  },
  {
    year: "2024",
  },
  {
    year: "2025",
  },
  {
    year: "2026",
  },
  {
    year: "2027",
  },
  {
    year: "2028",
  },
  {
    year: "2029",
  },
  {
    year: "2030",
  },
  {
    year: "2031",
  },
  {
    year: "2032",
  },
  {
    year: "2033",
  },
  {
    year: "2034",
  },
  {
    year: "2035",
  },
  {
    year: "2036",
  },
  {
    year: "2037",
  },
  {
    year: "2038",
  },
  {
    year: "2039",
  },
  {
    year: "2040",
  },
  {
    year: "2041",
  },
  {
    year: "2042",
  },
  {
    year: "2043",
  },
  {
    year: "2044",
  },
  {
    year: "2045",
  },
  {
    year: "2046",
  },
  {
    year: "2047",
  },
  {
    year: "2048",
  },
  {
    year: "2049",
  },
  {
    year: "2050",
  },
  {
    year: "2051",
  },
  {
    year: "2052",
  },
  {
    year: "2053",
  },
  {
    year: "2054",
  },
  {
    year: "2055",
  },
  {
    year: "2056",
  },
  {
    year: "2057",
  },
  {
    year: "2058",
  },
  {
    year: "2059",
  },
  {
    year: "2060",
  },
  {
    year: "2061",
  },
  {
    year: "2062",
  },
  {
    year: "2063",
  },
  {
    year: "2064",
  },
  {
    year: "2065",
  },
  {
    year: "2066",
  },
  {
    year: "2067",
  },
  {
    year: "2068",
  },
  {
    year: "2069",
  },
  {
    year: "2070",
  },
  {
    year: "2071",
  },
  {
    year: "2072",
  },
  {
    year: "2073",
  },
  {
    year: "2074",
  },
  {
    year: "2075",
  },
  {
    year: "2076",
  },
  {
    year: "2077",
  },
  {
    year: "2078",
  },
  {
    year: "2079",
  },
  {
    year: "2080",
  },
  {
    year: "2081",
  },
  {
    year: "2082",
  },
  {
    year: "2083",
  },
  {
    year: "2084",
  },
  {
    year: "2085",
  },
  {
    year: "2086",
  },
  {
    year: "2087",
  },
  {
    year: "2088",
  },
  {
    year: "2089",
  },
  {
    year: "2090",
  },
  {
    year: "2091",
  },
  {
    year: "2092",
  },
  {
    year: "2093",
  },
  {
    year: "2094",
  },
  {
    year: "2095",
  },
  {
    year: "2096",
  },
  {
    year: "2097",
  },
  {
    year: "2098",
  },
  {
    year: "2099",
  },
  {
    year: "2100",
  },
];

export default Years